import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import Download from '../../atoms/icons/Download';
import { readableDate, readableDateTime } from '../../../helpers/Date';
import Delete from '../../atoms/icons/Delete';
import { Link } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
const StyledTableCell = styled(TableCell) `
    min-width: 30px;
    flex: 0;

    svg {
        display: block;
        margin-left: auto;
    }

    &:hover {
        cursor: pointer;

        .icon {
            fill: ${props => props.theme.secondary};
        }
    }
`;
const StyledDownload = styled(Download) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;
`;
const StyledDeleteIcon = styled(Delete) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;
`;
const StyledDeleteButton = styled(({ asType: as, ...props }) => (_jsx(Link, { ...props, as: as }))) `
    background: transparent;
    border: 0;
    cursor: pointer;
    padding: 0;
`;
const Filter = styled.span `
    display: block;
`;
const ReportExportTableRow = ({ reportExport }) => {
    const { t } = useTranslation();
    return (_jsxs(TableRow, { children: [_jsx(TableCell, { label: "Label", value: reportExport.report.label }), _jsx(TableCell, { label: "Datum", value: readableDateTime(reportExport.created_at) }), _jsx(TableCell, { label: "Filter", value: Object.keys(reportExport.report.filters)
                    .filter(label => reportExport.report.filters[label])
                    .map(label => (_jsxs(Filter, { children: [_jsx("b", { children: label }), ": ", reportExport.report.filters[label]] }, label))) }), _jsx(TableCell, { label: "Status", value: `${reportExport.status_pretty} ${reportExport.status === 'running'
                    ? '(' + reportExport.progress + '%)'
                    : ''}` }), _jsx(TableCell, { label: "Verloopt op", value: readableDate(reportExport.expires_on) }), _jsx(StyledTableCell, { children: reportExport.status === 'finished' &&
                    !reportExport.is_expired && (_jsx("a", { href: `/rapportages/downloads/${reportExport.id}`, download: true, "aria-label": 'Download export', children: _jsx(StyledDownload, { className: "icon" }) })) }), _jsx(StyledTableCell, { children: _jsx(StyledDeleteButton, { href: `/rapportages/downloads/${reportExport.id}`, method: "DELETE", "aria-label": t('report_export.delete'), asType: "button", onClick: (e) => window.confirm(t('report_export.delete_confirm')) ||
                        e.preventDefault(), children: _jsx(StyledDeleteIcon, { className: "icon" }) }) })] }));
};
export default ReportExportTableRow;
